import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from 'primereact/button';
import { translate } from 'i18n/jhipster-language';
import PRow from 'shared/ui/prow';
import PCol from 'shared/ui/pcol';
/**
 * Compact toolbar: optional trailing actions + advanced search toggle + collapsible panel.
 * Matches the card schema list header pattern.
 */
export function TableHeaderWithAdvancedSearch({ showAdvanced, onToggleShowAdvanced, trailingActions, advancedPanel, }) {
    return (_jsxs("div", { style: { width: '100%' }, children: [_jsx(PRow, { className: "p-flex-wrap p-ai-start", style: { gap: '0.75rem' }, children: _jsxs(PCol, { col: "12", className: "p-d-flex p-jc-end p-ai-center p-flex-wrap", style: { gap: '0.5rem', marginTop: '0.5rem' }, children: [trailingActions, _jsx(Button, { type: "button", icon: showAdvanced ? 'pi pi-chevron-up' : 'pi pi-chevron-down', className: "p-button-outlined", label: translate('general.advancedSearch.toggle'), onClick: onToggleShowAdvanced })] }) }), showAdvanced && advancedPanel ? advancedPanel : null] }));
}
